import { Spinner } from "reactstrap";

const LoadingContainer = ({ isPending = true, children }) => {
  return isPending ? (
    <div className="flex text-center p-2">
      <Spinner>Loading...</Spinner>
    </div>
  ) : (
    children
  );
};

export default LoadingContainer;
